import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				// The KarroFin brand navy. It was registered only as `primary_2`,
				// so anything written `color="primary"` -- every themed button and
				// the pagination inside DataTable.vue -- painted a royal blue that
				// appears nowhere else in the design. The two names now agree;
				// `primary_2` is kept as an alias because 306 call sites use it.
				primary: '#194E76',
				secondary: '#b0bec5',
				accent: '#8c9eff',
				error: '#E50000',
				secondary_2: '#FA4616',
				primary_2: '#194E76',
				accent_2: '#D3D3D3',
				warning: '#F2C94C',
				table_header: "#fab376",
				table_header_2: "#fdd9bb",
				table_header_3: "#fef2e8",
				tab_header: "#fcf7ea",
			},
		},
	},
});